import WelcomeMessage from './WelcomeMessage';
export default WelcomeMessage;
export {default as useWelcomeMessage} from './useWelcomeMessage'